import { styled } from "styled-components";

const StyledInputWrapper = styled.div.attrs({ className: "sr-block" })`
  > div > div {
    border: transparent !important;
    padding: 0;
  }
`;

export { StyledInputWrapper };
